import { rankingCards } from '../../../mocks/ranking-cards';

export default function ComparisonTable() {
  const studentCards = [
    rankingCards[0], // 三井住友カード
    rankingCards[1], // 大手ECモール系カード
    rankingCards[6], // リクルートカード
    rankingCards[2], // スルガJCBカード
    rankingCards[4], // JAカード
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        <h3 className="text-3xl font-bold text-center mb-4 text-[#003366]">
          学生向けクレジットカード比較一覧表
        </h3>
        <p className="text-center text-gray-600 mb-12 max-w-2xl mx-auto">
          学生におすすめのクレジットカードを一覧で比較。年会費・還元率・特徴を確認して、自分に合ったカードを見つけましょう。
        </p>

        <div className="overflow-x-auto">
          <table className="w-full bg-white border-2 border-gray-200 rounded-lg">
            <thead>
              <tr className="bg-gradient-to-r from-[#14B8A6] to-[#0F9B8E] text-white">
                <th className="px-6 py-4 text-left font-bold">カード名</th>
                <th className="px-6 py-4 text-left font-bold">年会費</th>
                <th className="px-6 py-4 text-left font-bold">還元率</th>
                <th className="px-6 py-4 text-left font-bold">学生向け特徴</th>
                <th className="px-6 py-4 text-center font-bold">詳細</th>
              </tr>
            </thead>
            <tbody>
              {studentCards.map((card, index) => (
                <tr
                  key={card.id}
                  className={`border-b border-gray-200 hover:bg-gray-50 transition-all ${
                    index === 0 ? 'bg-[#14B8A6]/5' : ''
                  }`}
                >
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-3">
                      {index === 0 && (
                        <span className="bg-[#14B8A6] text-white text-xs px-2 py-1 rounded font-bold whitespace-nowrap">
                          1位
                        </span>
                      )}
                      <span className="font-bold text-[#003366]">{card.name}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4 text-[#14B8A6] font-bold">{card.annualFee}</td>
                  <td className="px-6 py-4 text-[#003366] font-bold">{card.returnRate}</td>
                  <td className="px-6 py-4 text-sm text-gray-700">
                    {card.benefits[0]}
                  </td>
                  <td className="px-6 py-4 text-center">
                    <a
                      href={card.detailUrl}
                      className="inline-block text-[#14B8A6] font-bold hover:underline cursor-pointer whitespace-nowrap"
                    >
                      詳細を見る
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-8 text-center text-sm text-gray-600">
          ※最新情報は各公式サイトをご確認ください。
        </div>
      </div>
    </section>
  );
}
